import React from 'react';
import StatCard from '../../../../Components/StatCard/StatCard';
import { useSelector } from 'react-redux';

function CouponStats() {
    const couponsInsights = useSelector((state) => state.reportAnalysis.couponsInsights.couponsInsights);

    return (
        <div className="grid grid-cols-4 gap-x-3 mx-5 mt-4">
            {
                Object.keys(couponsInsights).length > 0 && 
                <>
                    <StatCard 
                        statName="Total Coupons" 
                        statValue={couponsInsights.stats.totalCoupons} 
                    />
                    <StatCard 
                        statName="Active Coupons" 
                        statValue={couponsInsights.stats.activeCoupons} 
                    />
                    <StatCard 
                        statName="New Customers" 
                        statValue={0} 
                    />
                    <StatCard 
                        statName="Average Discount Provided" 
                        statValue={0} 
                        hasPercent={true} 
                    />
                </>
            }
        </div>
    )
}

export default CouponStats;
